import { useState } from "react";

import StreamlinedHeader from "client/common/components/header/StreamlinedHeader";
import Page from "client/common/components/layouts/Page";

import UnsubscribeConfirm from "./UnsubscribeConfirm";
import UnsubscribeReason from "./UnsubscribeReason";

import styles from "../styles/UnsubscribePage.module.less";

const UnsubscribePage = () => {
  const [unsubscribeId, setUnsubscribeId] = useState<number | undefined>(undefined);

  return (
    <Page Header={<StreamlinedHeader hasPrevious={false} />} Footer={null} className={styles.page}>
      <div className={styles.background} />
      <div className={styles.container}>
        <div className={styles.subcontainer}>
          {!unsubscribeId ? (
            <UnsubscribeConfirm onUnsubscribeCreate={setUnsubscribeId} />
          ) : (
            <UnsubscribeReason unsubscribeId={unsubscribeId} />
          )}
        </div>
      </div>
    </Page>
  );
};

export default UnsubscribePage;
